module.exports = __webpack_public_path__ + "static/installationspartner-caseimg-41c8e2dbed1c1550f45c94aae1330a03.jpg";